
 function addHiddenClassStyle() {
        var style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = '.hidden { display: none !important; }';
        document.getElementsByTagName('head')[0].appendChild(style);
    }
 addHiddenClassStyle();
function runMyFunction() {
   
    var elements = document.getElementsByClassName('m-megamenu__toggle');
        for (var i = 0; i < elements.length; i++) {
            elements[i].classList.add('hidden');
        }
}
var regex = /\.de\b/;
// Kiểm tra URL và chạy hàm
if (window.location.href.match(regex)) {
    runMyFunction();
}
